import { JOB_STATUSES_ENUM } from 'app/types/enums/jobStatuses';

export const getJobStatusTextClassName = (status: string) => {
  switch (status) {
    case JOB_STATUSES_ENUM.JOB_STATUS_COMPLETE:
      return 'text-[var(--color-job-status-complete)]';
    case JOB_STATUSES_ENUM.JOB_STATUS_PROCESSING:
    case JOB_STATUSES_ENUM.JOB_STATUS_TRANSCRIBING:
    case JOB_STATUSES_ENUM.JOB_STATUS_FINALIZING:
    case JOB_STATUSES_ENUM.JOB_STATUS_PROOFING:
    case JOB_STATUSES_ENUM.JOB_STATUS_READY_FOR_TRANSCRIBING:
    case JOB_STATUSES_ENUM.JOB_STATUS_READY_FOR_PROOFREADING:
    case JOB_STATUSES_ENUM.JOB_STATUS_READY_FOR_FINAL:
      return 'text-[var(--color-job-status-progress)]';
    case JOB_STATUSES_ENUM.JOB_STATUS_ERROR:
    case 'Deleted':
      return 'text-[var(--color-job-status-error)]';
    default:
      return 'text-[var(--color-text-muted)]';
  }
};
